@use "../../../../../../../../styles/Colors.scss" as Colors;
@use "../../../../../../../../styles/Constants.scss" as Constants;

.MaterialEntry {
	flex: 1;

	.nameAndGroups {
		display: flex;
		flex-direction: row;
		align-items: center;

		.name {
			font-size: Constants.$val-fontSizeRegular;
			line-height: Constants.$val-lineHeightRegular;
			font-weight: 700;
		}

		.groups {
			font-size: Constants.$val-fontSizeSmall;
			line-height: Constants.$val-lineHeightSmall;
			margin-left: Constants.$val-spacing-m;
		}
	}

	.description, .vendorLine {
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-lineHeightSmall;
		color: Colors.$col-design-grey10;
		margin-top: Constants.$val-spacing-xs;

		&.missing {
			font-style: italic;
		}

		.notAssigned {
			font-style: italic;
		}
	}
}
